var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tdesign:order-descending"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 4H8.97221V4.9188H3V4ZM3 7.2158H8.97221V8.1346H3V7.2158ZM3.4594 10.4316H3V11.3504H8.05341V10.4316H3.4594ZM10.8098 12L11.1346 11.6752L12.5128 10.297L12.8376 9.97221L12.188 9.32261L11.8632 9.64741L11.2692 10.2414V4H10.3504V10.2414L9.7564 9.64741L9.43161 9.32261L8.78202 9.97221L9.10681 10.297L10.485 11.6752L10.8098 12Z",
    fill: "#7BC1FE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescending);
export default __webpack_public_path__ + "static/media/Descending.cc7c678e6c0d4ca88cb18efa97169fec.svg";
export { ForwardRef as ReactComponent };